import {jsx} from 'panel';

export const InvisibleSubmit = () => {
  return (
    <input
      //hack to allow form submits via enter button
      attrs={{type: `submit`, tabindex: -1}}
      style={{position: `absolute`, left: `-9999px`, width: `1px`, height: `1px`}}
    />
  );
};
